/* My Energy Global — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  var T = window.theme || {};
  var R = T.routes || {};
  var S = T.settings || {};
  var STR = T.strings || {};

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }

  // Root URL may be "/" or a localized prefix like "/en-ca" (no trailing slash).
  // Normalize so concatenation is always correct.
  function rootUrl(path) {
    var base = (R.root || '/').replace(/\/+$/, '');
    return base + '/' + String(path || '').replace(/^\/+/, '');
  }

  function formatMoney(cents) {
    var fmt = S.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  var focusTrapStack = [];
  function trapFocus(container) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    function handler(e) {
      if (e.key !== 'Tab') return;
      var items = $$(sel, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    focusTrapStack.push({ container: container, handler: handler, prev: document.activeElement });
    var firstEl = $$(sel, container).filter(function (el) { return el.offsetParent !== null; })[0];
    if (firstEl) setTimeout(function () { firstEl.focus(); }, 60);
  }
  function releaseFocus() {
    var t = focusTrapStack.pop();
    if (!t) return;
    t.container.removeEventListener('keydown', t.handler);
    if (t.prev && t.prev.focus) t.prev.focus();
  }

  var scrollLockCount = 0;
  function lockScroll() {
    if (scrollLockCount === 0) {
      var sw = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (sw > 0) document.body.style.paddingRight = sw + 'px';
    }
    scrollLockCount++;
  }
  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  /* ---------- toasts ---------- */
  var CHECK_ICON = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 10.5l4 4 8-9"/></svg>';
  var WARN_ICON = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="10" cy="10" r="8"/><path d="M10 6v5M10 14h.01"/></svg>';

  function toast(message, type) {
    var region = $('[data-toast-region]');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'toast' + (type === 'error' ? ' toast--error' : '');
    el.setAttribute('role', 'status');
    el.innerHTML = (type === 'error' ? WARN_ICON : CHECK_ICON) + '<span></span>';
    el.querySelector('span').textContent = message;
    region.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 260);
    }, 3800);
  }

  /* ---------- announcement bar ---------- */
  function initAnnouncementBar() {
    var bar = $('[data-announcement-bar]');
    if (!bar) return;
    var key = 'meg_announcement_dismissed';
    var id = bar.getAttribute('data-announcement-id') || '1';
    try {
      if (sessionStorage.getItem(key) === id) { bar.hidden = true; return; }
    } catch (e) { /* storage blocked */ }

    on($('[data-announcement-close]', bar), 'click', function () {
      bar.hidden = true;
      try { sessionStorage.setItem(key, id); } catch (e) {}
    });

    var slides = $$('[data-announcement-slide]', bar);
    if (slides.length > 1 && bar.getAttribute('data-auto-rotate') === 'true') {
      var i = 0;
      var speed = parseInt(bar.getAttribute('data-rotate-speed'), 10) || 6;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed * 1000);
    }
  }

  /* ---------- header: desktop dropdowns ---------- */
  function initHeaderNav() {
    var items = $$('[data-nav-item-parent]');
    var closeTimer;

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var trigger = $('[data-nav-trigger]', item);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function (item) {
      var trigger = $('[data-nav-trigger]', item);

      on(item, 'mouseenter', function () {
        clearTimeout(closeTimer);
        closeAll(item);
        item.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      });

      on(item, 'mouseleave', function () {
        closeTimer = setTimeout(function () {
          item.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, 140);
      });

      on(trigger, 'click', function (e) {
        // Allow keyboard/touch toggle without following the link
        e.preventDefault();
        var open = item.classList.contains('is-open');
        closeAll();
        if (!open) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });

    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    on(document, 'click', function (e) {
      if (!e.target.closest('[data-nav-item-parent]')) closeAll();
    });
  }

  /* ---------- generic drawers ---------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    trapFocus(drawer);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
    releaseFocus();
  }

  function initDrawers() {
    $$('[data-drawer-open]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        openDrawer($('#' + btn.getAttribute('data-drawer-open')));
      });
    });
    $$('[data-drawer]').forEach(function (drawer) {
      $$('[data-drawer-close]', drawer).forEach(function (btn) {
        on(btn, 'click', function () { closeDrawer(drawer); });
      });
      on($('[data-drawer-overlay]', drawer), 'click', function () { closeDrawer(drawer); });
    });
    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = $('[data-drawer].is-open');
      if (open) closeDrawer(open);
    });
  }

  /* ---------- mobile nav accordion ---------- */
  function initMobileNav() {
    $$('[data-mobile-nav-toggle]').forEach(function (btn) {
      on(btn, 'click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var sub = btn.nextElementSibling;
        if (sub) sub.classList.toggle('is-open', !expanded);
      });
    });
  }

  /* ---------- collection filters (mobile) ---------- */
  function initFilters() {
    var filters = $('[data-filters]');
    if (!filters) return;

    $$('[data-filters-open]').forEach(function (btn) {
      on(btn, 'click', function () {
        filters.classList.add('is-open');
        lockScroll();
        trapFocus(filters);
      });
    });

    function close() {
      if (!filters.classList.contains('is-open')) return;
      filters.classList.remove('is-open');
      unlockScroll();
      releaseFocus();
    }
    $$('[data-filters-close]', filters).forEach(function (b) { on(b, 'click', close); });
    on($('[data-filters-overlay]', filters), 'click', close);
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });

    // Auto-submit on change (desktop)
    var form = $('[data-filters-form]', filters);
    if (form) {
      on(form, 'change', function (e) {
        if (e.target.matches('input[type="checkbox"], select')) {
          if (window.matchMedia('(min-width: 1000px)').matches) form.submit();
        }
      });
    }

    // Sort
    var sort = $('[data-sort-select]');
    on(sort, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- quantity selectors ---------- */
  function initQuantity(scope) {
    $$('[data-qty]', scope || document).forEach(function (wrap) {
      if (wrap.dataset.qtyBound === 'true') return;
      wrap.dataset.qtyBound = 'true';

      var input = $('[data-qty-input]', wrap);
      var minus = $('[data-qty-minus]', wrap);
      var plus = $('[data-qty-plus]', wrap);
      if (!input) return;

      function sync() {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        var max = input.max ? parseInt(input.max, 10) : Infinity;
        if (minus) minus.disabled = val <= min;
        if (plus) plus.disabled = val >= max;
      }

      function step(delta) {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        var max = input.max ? parseInt(input.max, 10) : Infinity;
        var next = Math.min(max, Math.max(min, val + delta));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      }

      on(minus, 'click', function () { step(-1); });
      on(plus, 'click', function () { step(1); });
      on(input, 'change', sync);
      sync();
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery(scope) {
    $$('[data-gallery]', scope || document).forEach(function (gallery) {
      if (gallery.dataset.galleryBound === 'true') return;
      gallery.dataset.galleryBound = 'true';

      var track = $('[data-gallery-track]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      var dots = $$('[data-gallery-dot]', gallery);
      if (!track) return;

      function setActive(idx) {
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }

      function goTo(idx) {
        var slide = track.children[idx];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(idx);
      }

      thumbs.forEach(function (thumb, i) {
        on(thumb, 'click', function () { goTo(i); });
      });

      var raf;
      on(track, 'scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          setActive(idx);
        });
      }, { passive: true });

      // Jump to a media id (variant change)
      gallery.selectMedia = function (mediaId) {
        var target = $('[data-media-id="' + mediaId + '"]', track);
        if (!target) return;
        goTo(Array.prototype.indexOf.call(track.children, target));
      };

      setActive(0);
    });
  }

  /* ---------- variant selection ---------- */
  function initVariants(scope) {
    $$('[data-product-form]', scope || document).forEach(function (form) {
      if (form.dataset.variantsBound === 'true') return;
      form.dataset.variantsBound = 'true';

      var dataEl = $('[data-product-json]', form.closest('[data-product-root]') || document);
      if (!dataEl) return;

      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!product || !product.variants) return;

      var root = form.closest('[data-product-root]') || document;
      var idInput = $('[data-variant-id]', form);
      var submitBtn = $('[data-add-to-cart]', form);
      var submitText = submitBtn ? $('[data-add-to-cart-text]', submitBtn) : null;
      var priceEl = $('[data-price-block]', root);
      var skuEl = $('[data-variant-sku]', root);
      var availEl = $('[data-variant-availability]', root);
      var qtyInput = $('[data-qty-input]', form);
      var gallery = $('[data-gallery]', root);

      function currentOptions() {
        return $$('[data-variant-option]', form).map(function (input) {
          if (input.tagName === 'SELECT') return input.value;
          return null;
        }).filter(Boolean).concat(
          $$('[data-variant-option-group]', form).map(function (group) {
            var checked = $('input:checked', group);
            return checked ? checked.value : null;
          }).filter(Boolean)
        );
      }

      function findVariant() {
        var opts = currentOptions();
        return product.variants.filter(function (v) {
          return opts.every(function (opt, i) { return v.options[i] === opt; });
        })[0];
      }

      function render(variant) {
        if (!variant) {
          if (submitBtn) { submitBtn.disabled = true; }
          if (submitText) submitText.textContent = STR.unavailable || 'Unavailable';
          return;
        }

        if (idInput) idInput.value = variant.id;

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        if (priceEl) {
          var html = '<span class="price__regular">' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
            priceEl.classList.add('price--on-sale');
          } else {
            priceEl.classList.remove('price--on-sale');
          }
          priceEl.innerHTML = html;
        }

        if (skuEl) {
          skuEl.textContent = variant.sku || '';
          skuEl.hidden = !variant.sku;
        }

        if (availEl) {
          availEl.classList.toggle('product-info__availability--in', variant.available);
          availEl.classList.toggle('product-info__availability--out', !variant.available);
          availEl.textContent = availEl.getAttribute(
            variant.available ? 'data-label-in' : 'data-label-out'
          ) || '';
        }

        if (submitBtn) submitBtn.disabled = !variant.available;
        if (submitText) {
          submitText.textContent = variant.available
            ? (STR.addToCart || 'Add to cart')
            : (STR.soldOut || 'Sold out');
        }

        if (qtyInput) {
          if (variant.inventory_management && variant.inventory_policy === 'deny' && variant.inventory_quantity > 0) {
            qtyInput.max = variant.inventory_quantity;
          } else {
            qtyInput.removeAttribute('max');
          }
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (gallery && gallery.selectMedia && variant.featured_media) {
          gallery.selectMedia(variant.featured_media.id);
        }

        // Disable unavailable option pills
        $$('[data-variant-option-group]', form).forEach(function (group, groupIdx) {
          $$('input', group).forEach(function (input) {
            var test = currentOptions().slice();
            test[groupIdx] = input.value;
            var exists = product.variants.some(function (v) {
              return test.every(function (o, i) { return v.options[i] === o; }) && v.available;
            });
            input.disabled = !exists;
          });
        });
      }

      on(form, 'change', function (e) {
        if (e.target.matches('[data-variant-option], [data-variant-option-group] input')) {
          render(findVariant());
        }
      });

      render(findVariant() || product.variants[0]);
    });
  }

  /* ---------- cart ---------- */
  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || STR.cartError);
        return data;
      });
    });
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartDrawer() {
    return fetch(rootUrl('?section_id=cart-drawer'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-drawer-content]', doc);
        var current = $('[data-cart-drawer-content]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          initQuantity(current);
        }
      });
  }

  function initAddToCart() {
    on(document, 'submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();

      var btn = $('[data-add-to-cart]', form);
      var text = btn ? $('[data-add-to-cart-text]', btn) : null;
      var original = text ? text.textContent : '';
      if (btn) btn.disabled = true;
      if (text) text.textContent = '…';

      var fd = new FormData(form);
      var payload = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 }] };

      cartRequest(R.cartAdd, payload)
        .then(function () {
          return fetch(rootUrl('cart.js')).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          toast(STR.addedToCart || 'Added to cart');
          if (S.cartType === 'drawer') {
            return refreshCartDrawer().then(function () {
              openDrawer($('#CartDrawer'));
            });
          }
          window.location.href = R.cart;
        })
        .catch(function (err) { toast(err.message || STR.cartError, 'error'); })
        .then(function () {
          if (btn) btn.disabled = false;
          if (text) text.textContent = original;
        });
    });
  }

  function initCartUpdates() {
    // Quantity change / remove inside cart drawer or cart page
    on(document, 'change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      changeLine(input.getAttribute('data-line'), parseInt(input.value, 10) || 0);
    });

    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;
      e.preventDefault();
      changeLine(btn.getAttribute('data-line'), 0);
    });

    function changeLine(line, quantity) {
      if (!line) return;
      cartRequest(R.cartChange, { line: parseInt(line, 10), quantity: quantity })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if ($('[data-cart-page]')) { window.location.reload(); return; }
          return refreshCartDrawer();
        })
        .catch(function (err) { toast(err.message || STR.cartError, 'error'); });
    }

    // Cart note
    var note = $('[data-cart-note]');
    if (note) {
      var noteTimer;
      on(note, 'input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          cartRequest(R.cartUpdate, { note: note.value }).catch(function () {});
        }, 600);
      });
    }
  }

  /* ---------- quick view ---------- */
  function initQuickView() {
    var modal = $('#QuickViewModal');
    if (!modal) return;
    var body = $('[data-quick-view-body]', modal);

    function close() {
      if (!modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      releaseFocus();
      if (body) body.innerHTML = '';
    }

    $$('[data-modal-close]', modal).forEach(function (b) { on(b, 'click', close); });
    on($('[data-modal-overlay]', modal), 'click', close);
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });

    on(document, 'click', function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();

      var handle = trigger.getAttribute('data-quick-view');
      if (!handle) return;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll();
      if (body) body.innerHTML = '<div class="modal__loading"><div class="spinner" role="status" aria-label="Loading"></div></div>';

      fetch(rootUrl('products/' + handle + '?section_id=quick-view-content'))
        .then(function (r) {
          if (!r.ok) throw new Error();
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = $('[data-quick-view-content]', doc);
          if (!content || !body) throw new Error();
          body.innerHTML = content.innerHTML;
          initQuantity(body);
          initGallery(body);
          initVariants(body);
          trapFocus(modal);
        })
        .catch(function () {
          close();
          window.location.href = rootUrl('products/' + handle);
        });
    });
  }

  /* ---------- sticky add-to-cart ---------- */
  function initStickyAtc() {
    var sticky = $('[data-sticky-atc]');
    var form = $('[data-product-form]');
    if (!sticky || !form || !S.stickyAtc) return;
    if (!window.IntersectionObserver) return;

    document.body.classList.add('has-sticky-atc');
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(form);

    on($('[data-sticky-atc-btn]', sticky), 'click', function () {
      var btn = $('[data-add-to-cart]', form);
      if (btn) btn.click();
    });
  }

  /* ---------- predictive search ---------- */
  function initSearch() {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results || !R.predictiveSearch) return;

    var timer;
    var controller;

    on(input, 'input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }

      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();

        var url = R.predictiveSearch +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,article,page&resources[limit]=6' +
          '&section_id=predictive-search';

        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = $('[data-predictive-inner]', doc);
            results.innerHTML = fresh ? fresh.innerHTML : '';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- back to top ---------- */
  function initBackToTop() {
    var btn = $('[data-back-to-top]');
    if (!btn) return;
    var ticking = false;

    function check() {
      btn.hidden = window.scrollY < 500;
      ticking = false;
    }

    on(window, 'scroll', function () {
      if (!ticking) { requestAnimationFrame(check); ticking = true; }
    }, { passive: true });

    on(btn, 'click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    check();
  }

  /* ---------- sticky header offset var ---------- */
  // Writes --header-offset only. Never write --header-h: that is the header's own
  // min-height, and feeding a measured value back into it creates a growth loop.
  function initHeaderHeight() {
    var header = $('[data-site-header]');
    if (!header) return;
    function measure() {
      document.documentElement.style.setProperty('--header-offset', header.offsetHeight + 'px');
    }
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(header);
    else on(window, 'resize', measure);
  }

  /* ---------- scroll animations ---------- */
  function initAnimations() {
    if (!S.animations || !window.IntersectionObserver) {
      $$('[data-animate]').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    $$('[data-animate]').forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 6, 5) * 60 + 'ms';
      io.observe(el);
    });
  }

  /* ---------- sliders ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (slider) {
      var track = $('[data-slider-track]', slider);
      var prev = $('[data-slider-prev]', slider);
      var next = $('[data-slider-next]', slider);
      if (!track) return;

      function scrollBy(dir) {
        var first = track.firstElementChild;
        var amount = first ? first.offsetWidth + 24 : track.clientWidth * 0.8;
        track.scrollBy({ left: amount * dir, behavior: 'smooth' });
      }

      function sync() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }

      on(prev, 'click', function () { scrollBy(-1); });
      on(next, 'click', function () { scrollBy(1); });
      on(track, 'scroll', sync, { passive: true });
      on(window, 'resize', sync);
      sync();
    });
  }

  /* ---------- currency / locale selectors ---------- */
  function initLocaleForms() {
    $$('[data-locale-form] select').forEach(function (select) {
      on(select, 'change', function () {
        select.closest('form').submit();
      });
    });
  }

  /* ---------- init ---------- */
  function init() {
    initAnnouncementBar();
    initHeaderNav();
    initHeaderHeight();
    initDrawers();
    initMobileNav();
    initFilters();
    initQuantity();
    initGallery();
    initVariants();
    initAddToCart();
    initCartUpdates();
    initQuickView();
    initStickyAtc();
    initSearch();
    initBackToTop();
    initAnimations();
    initSliders();
    initLocaleForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor events
  document.addEventListener('shopify:section:load', function (e) {
    initQuantity(e.target);
    initGallery(e.target);
    initVariants(e.target);
    initHeaderNav();
    initSliders();
    initAnimations();
  });

  window.MEG = { toast: toast, openDrawer: openDrawer, closeDrawer: closeDrawer, formatMoney: formatMoney };
})();
